"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WebOSCapabilities = (function () {
    function WebOSCapabilities() {
    }
    WebOSCapabilities.prototype.hasLifecycleSuspension = function () {
        return true;
    };
    WebOSCapabilities.prototype.hasNativeParentalPin = function () {
        return false;
    };
    WebOSCapabilities.prototype.hasExternalAppsDisplay = function () {
        return false;
    };
    WebOSCapabilities.prototype.hasVolumeControl = function () {
        return false;
    };
    WebOSCapabilities.prototype.hasExternalAppsLaunch = function () {
        return false;
    };
    return WebOSCapabilities;
}());
exports.WebOSCapabilities = WebOSCapabilities;
